import { useState, useEffect } from 'react';
import { useOutletContext } from "react-router-dom";

import {translations} from './../../i18/translations.js';

const NewsLetterMyAdmin = () => {

    const API_URL = process.env.REACT_APP_SERVICE_API_URL;

    const {user, lang, showAlert, checkAccess} = useOutletContext();

    const [newsletters, setNewsletters] = useState([]);

    const fetchLetters = async () => {
        try {
            const response = await fetch(`${API_URL}/admin/get_newsletter_myadmin_list.php`);
            const data = await response.json();
            setNewsletters(data);
        } catch (error) {
            console.error('Error fetching search results:', error);
        }
    };

    useEffect(() => {
        fetchLetters();
    }, [lang, user]);

    const submitSubsciption = async (payload) => {
        try {
            const response = await fetch(`${API_URL}/admin/set_newsletter_subscription.php`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(payload)
            });
            const data = await response.json();
            if (checkAccess(data)) {
                showAlert(data.alert);
                fetchLetters();
            }
        } catch (error) {
            console.error('Error fetching search results:', error);
        }
    };

    const handleSubscriptionChange = (id, value) => {
        const payload = {
            subscriptiondata: {
                newsLetterId: id,
                subscription: value
            }
        };
        submitSubsciption(payload);
    };

    return (
            <div>
                <h1 className="mbkegy-content">{translations[lang].newsletter_myadmin}</h1>    
            
                <div className="text-center mb-4" style={{whiteSpace: 'pre-line'}}>{translations[lang].newsletter_myadmin_desc}</div>
            
                <table className="table table-striped">
                    <thead>
                        <tr>
                            <th>{translations[lang].theme}</th>
                            <th>{translations[lang].last_sent}</th>
                            <th>{translations[lang].subscription}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {newsletters.map((newsletter) => (
                                <tr key={newsletter.id}>
                                    <td>{newsletter.name}</td>
                                    <td>{newsletter.lastUsed || translations[lang].no_data}</td>
                                    <td>
                                        <div className="form-check form-switch">
                                            <input
                                                className="form-check-input"
                                                type="checkbox"
                                                id={`newsletter-${newsletter.id}`}
                                                checked={newsletter.subscription === '1'}
                                                onChange={(e) =>
                                                                    handleSubscriptionChange(
                                                                            newsletter.id,
                                                                            e.target.checked ? '1' : '0'
                                                                            )
                                                                                                                                                                                                              }
                                                />
                                            <label className="form-check-label" htmlFor={`newsletter-${newsletter.id}`}>                                                        
                                            </label>
                                        </div>
                                    </td>
                                </tr>
                                        ))}
                    </tbody>
                </table>
            </div>
            );
};

export default NewsLetterMyAdmin;
